// import React from "react";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import { Button } from "react-bootstrap";

// const StockExport = ({ stockList }) => {
//   const exportToExcel = () => {
//     if (!stockList || stockList.length === 0) {
//       alert("No data available to export!");
//       return;
//     }

//     // 🔥 Format Data agar lebih rapi di Excel
//     const formattedData = stockList.map(({ id, name, category, stock }) => ({
//       "Product ID": id,
//       "Product Name": name,
//       "Category": category,
//       "Stock": stock,
//     }));

//     const ws = XLSX.utils.json_to_sheet(formattedData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Stock Data");

//     // 🔥 Buat file Excel
//     const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

//     saveAs(data, `Stock_Report_${new Date().toISOString().slice(0, 10)}.xlsx`);
//   };

//   return (
//     <Button variant="success" onClick={exportToExcel}>
//       📤 Export to Excel
//     </Button>
//   );
// };

// export default StockExport;

import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Button } from "react-bootstrap";

const StockExport = ({ stockList, history }) => {
  const exportStockToExcel = () => {
    if (!stockList || stockList.length === 0) {
      alert("No stock data available to export!");
      return;
    }

    const formattedStock = stockList.map(({ id, name, category, stock }) => ({
      "Product ID": id,
      "Product Name": name,
      "Category": category,
      "Stock": stock,
    }));

    const ws = XLSX.utils.json_to_sheet(formattedStock);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Stock Data");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(data, `Stock_Report_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  const exportHistoryToExcel = () => {
    if (!history || history.length === 0) {
      alert("No history data available to export!");
      return;
    }

    const formattedHistory = history.map(({ id, product, change, date }) => ({
      "Transaction ID": id,
      "Product": product,
      "Stock Change": change > 0 ? `+${change}` : change,
      "Date": date,
    }));

    const ws = XLSX.utils.json_to_sheet(formattedHistory);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Stock History");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(data, `Stock_History_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  return (
    <div className="d-flex gap-2">
      <Button variant="success" onClick={exportStockToExcel}>
        📤 Export Stock
      </Button>
      <Button variant="primary" onClick={exportHistoryToExcel}>
        📅 Export History
      </Button>
    </div>
  );
};

export default StockExport;
